module.exports = __webpack_public_path__ + "img/9788949120973.7d735dfd.jpg";